import { createFileRoute, notFound } from "@tanstack/react-router";

import { workspacesQueries } from "@/api/resources/workspaces/queries";
import WorkspaceCustomerPage from "@/components/WorkspaceCustomer/WorkspaceCustomerPage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/customer-workspaces/$customer_workspace_id/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.customer-workspaces"),
        icon: <Icon.CUSTOMER_WORKSPACES />,
        path: "/workspaces/$workspace_id/customer-workspaces",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id, customer_workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    const currentCustomerWorkspace = await context.queryClient.ensureQueryData(
      workspacesQueries.byId(customer_workspace_id),
    );
    if (!currentCustomerWorkspace) throw notFound();

    const breadcrumbs: BreadcrumbsContext[] = [{ label: currentCustomerWorkspace.name, icon: <Icon.WORKSPACE /> }];
    context.breadcrumbs.splice(2, 1, ...breadcrumbs);
  },
  component: WorkspaceCustomerPage,
});
